module.exports = __webpack_public_path__ + "img/summary_analysed.3945c22.svg";